<template>
	<span>{{ readable }}</span>
</template>

<script>

export default {
	name: "DateSpan",
	props: { date: { required: true, type: String }, format: { type: String, default: "d-M-Y" }, onlyTime: Boolean },
	computed: {
		readable () {
			let date = this.date;
			if (!date) return "";

			if (this.onlyTime) {
				date = "1970-01-01T" + this.date;
			}
			return new Date(date).toLocaleDateString();
		},
	},
};
</script>

<style scoped>

</style>
